var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Metric } from '../../metrics';
import { toErrorMessage } from '../../util';
import TENANT_ID from '../../config/TenantId';
import Debug from '../../util/Debug';
const storageProviderWrapper = (storageProvider) => {
    const { storageName, getWithKey, setWithKey, deleteWithKey, } = storageProvider();
    return {
        getObjectWithKey: (key, defaultObject) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            let persistedObject = defaultObject;
            try {
                const storedJsonString = yield getWithKey(key);
                if (storedJsonString !== undefined && storedJsonString !== null) {
                    persistedObject = JSON.parse(storedJsonString);
                }
                else {
                    Debug.warn(`${storageName} - Key:${key} returned null object`);
                }
                Metric('GetPersistedObjectWithKey', TENANT_ID, {
                    attributes: {
                        storageProvider: storageName,
                        payloadSize: (_a = storedJsonString === null || storedJsonString === void 0 ? void 0 : storedJsonString.length) !== null && _a !== void 0 ? _a : 0,
                        key,
                    },
                }).put();
            }
            catch (e) {
                const error = toErrorMessage(e);
                Metric('GetPersistedObjectWithKeyError', TENANT_ID, {
                    attributes: { error, storageProvider: storageName, key },
                }).put();
            }
            return persistedObject;
        }),
        setObjectWithKey: (key, object) => __awaiter(void 0, void 0, void 0, function* () {
            var _b;
            try {
                const storeJsonString = JSON.stringify(object);
                yield setWithKey(key, storeJsonString);
                Metric('SetPersistedObjectWithKey', TENANT_ID, {
                    attributes: {
                        storageProvider: storageName,
                        payloadSize: (_b = storeJsonString === null || storeJsonString === void 0 ? void 0 : storeJsonString.length) !== null && _b !== void 0 ? _b : 0,
                        key,
                    },
                }).put();
            }
            catch (e) {
                const error = toErrorMessage(e);
                Metric('SetPersistedObjectWithKeyError', TENANT_ID, {
                    attributes: { error, storageProvider: storageName, key },
                }).put();
            }
        }),
        deleteObjectWithKey: (key) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield deleteWithKey(key);
                Metric('DeletePersistedObjectWithKey', TENANT_ID, {
                    attributes: {
                        storageProvider: storageName,
                        key,
                    },
                }).put();
            }
            catch (e) {
                const error = toErrorMessage(e);
                Metric('DeletePersistedObjectWithKeyError', TENANT_ID, {
                    attributes: { error, storageProvider: storageName, key },
                }).put();
            }
        }),
    };
};
export default storageProviderWrapper;
//# sourceMappingURL=storageProviderWrapper.js.map